// extracted by mini-css-extract-plugin
export default {"content":"NotifyYourTeam_content__nGzK5","skeletonLoadingAnimation":"NotifyYourTeam_skeletonLoadingAnimation__GrgAg"};